import { Card, CardContent, Stack, Typography } from "@mui/material";

const NotConfigured = ({ user }: any) => {

    return (
        <Stack
            spacing={2}
            direction="column"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            }}>
            <Card
                sx={{
                    color: "#fff",
                    width: "400px",
                    height: "450px",
                    background: "#2e3038",
                    boxShadow: "none",
                    borderRadius: "4px"
                }}
            >
                <CardContent>
                    <Stack spacing={0} mt={5}>
                        <Typography component="p" color="grey" style={{
                            textAlign: "center",
                            fontSize: "18px",
                            fontWeight: "600",
                            width: "100%"
                        }}>
                            {user?.display_name ?? ""}{" "}
                            {user?.type === "1"
                                ? " (Basic)"
                                : user?.type === "2"
                                    ? " (Licensed)"
                                    : ""}
                        </Typography>
                        <Typography component="p" color="grey" style={{
                            textAlign: "center",
                            fontSize: "16px",
                            fontWeight: "500",
                            width: "100%"
                        }}>
                            {user?.email ?? ""}
                        </Typography>
                    </Stack>
                    <Stack mt={10}>
                        <Typography component="p" color="whitesmoke" style={{
                            textAlign: "center",
                            fontSize: "16px",
                            fontWeight: "500",
                            lineHeight: "25px"
                        }}>
                            Your account is not yet configured to use Verbatim. Please contact Support to have it enabled.
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    )
}

export default NotConfigured;